import { useContext } from 'react';

import { pattern } from '@endurancewarranty/lib';
import { UserContext } from '@lib/auth/UserContextProvider';

import type { TUser } from '@models/authorization/TUser';

const { isMatching, P } = pattern;

export type TUseCurrentUser = Readonly<{
  user: TUser;
  isCustomerService: boolean;
  isRetention: boolean;
  isBilling: boolean;
  isSdr: boolean;
}>;

export function useCurrentUser(): TUseCurrentUser {
  const ctx = useContext(UserContext);

  if (ctx == null) {
    throw new Error('useCurrentUser must be used within UserContextProvider');
  }

  const { user } = ctx;

  const isBilling = user.roles.some(isMatching({ roleKey: P.string.startsWith('billing') }));
  const isSdr = user.roles.some(isMatching({ roleKey: 'sales-agent-sdr' }));

  const isCustomerService = user.roles.some(isMatching({ roleKey: 'customer-service' }));

  const isRetention = user.roles.some(
    isMatching({
      roleKey: P.union('retention-agent', 'retention-manager'),
    }),
  );

  return {
    user,
    isCustomerService,
    isRetention,
    isBilling,
    isSdr,
  };
}
